import { Link, LinkProps } from 'react-router-dom'

import styled, { css } from 'styled-components'

import { TBtnCardStyle } from './types'

const Base = css`
  min-height: 100px;
  width: calc(100% - 30px);
  margin: 5px;
  border-radius: 15px;
  padding: 0px 20px 0px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.06);
  user-select: none;
  transition: all 0.15s linear;
  color: ${p => p.theme.colors.dark};

  :hover,
  :focus,
  :active {
    box-shadow: 0 0 10px 0.5px rgba(0, 0, 0, 0.2);
    transform: scale(0.99);
    cursor: pointer;
    outline: none;
  }
`

const Wrapper = styled(Link)<LinkProps>`
  ${Base}
`

const WrapperCustom = styled.div`
  ${Base}
`

const IconContainer = styled.div<TBtnCardStyle>`
  height: 90px;
  width: 90px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: ${(p: TBtnCardStyle) => p.size ?? '25px'};
  }
`

const Body = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px 0;
`

const Title = styled.h2`
  font-size: 1rem;
  font-weight: 400;
  margin-bottom: 9px;
`

const Description = styled.h4`
  font-size: 0.8rem;
  opacity: 0.7;
  font-weight: 500;
  line-height: 1.1;
`

export { Wrapper, WrapperCustom, IconContainer, Body, Title, Description }
